"use strict";
exports.startOfDecade = startOfDecade;
var _index = require("./toDate.js");
function startOfDecade(date) {
  const _date = (0, _index.toDate)(date);
  const year = _date.getFullYear();
  const decade = Math.floor(year / 10) * 10;
  _date.setFullYear(decade, 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
